<template>
  <f7-page class="fpc-body" :page-content="false">
    <div class="fpc-header">
       <p>{{ survey.title }}</p>
       <p>{{ survey.description }}</p>
    </div>
    <f7-card class="fpc-cards">
      <div class="fpc-separated">
        <div class="fpc-labels">
          Progreso de la encuesta
        </div>
        <div>
          {{ currentPage }} de {{ maxPages }}
        </div>
      </div>
      <div class="fpc-progress">
        <div class="fpc-progress-up" :style="progress" ></div>
      </div>
      <div class="fpc-progress-icon-list">
        <div class="fpc-progress-icon" v-for="(item, index) in survey.sections" :key="item.id" @click="goPage(index+1)" >
          <img v-if="check" src="assets/img/otros/check.png" alt="" width="16" style="position: absolute; top: 10px; right: 30px;">
          <div v-if="item.iconType === 'material-icon'">
            <i class="material-icons">{{ item.icon }}</i>
          </div>
          <div v-else>
            <img :src="item.icon" alt="" width="28" class="m-l-0">
          </div>
          <div class="fpc-title-section">
            {{ item.title }}
          </div>
        </div>
      </div>
    </f7-card>
    <f7-card class="fpc-cards" v-for="item in survey.sections" :key="item.id" v-show="sectionVisible(item.id)">
      <div class="fpc-header-section">
        <p>{{ item.title }}</p>
        <p>{{ item.description }}</p>
        <question v-for="questionItem in item.questions" :key="questionItem.id" :data="questionItem"></question>
        <div class="end-message" v-if="messageInBottom">{{ messageInBottom }}</div>
      </div>
      <div class="fpc-separated">
        <div>
          <f7-button large raised @click="movePages(-1)" v-if="!(currentPage === 1)">
            <div class="fpc-separated">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 14px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left "><path d="m15 18-6-6 6-6"></path></svg>
              </div>
              <div>
                Anterior
              </div>
            </div>
          </f7-button>
        </div>
        <div>
          <f7-button large fill @click="movePages(1)" v-if="!(currentPage === maxPages)" >
            <!-- :disabled="currentPage === maxPages" -->
            <div class="fpc-separated">
              <div>
                Siguiente
              </div>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 14px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right "><path d="m9 18 6-6-6-6"></path></svg>
              </div>
            </div>
          </f7-button>
          <f7-button large fill @click="sendForm" v-if="currentPage === maxPages">
            <div class="fpc-separated">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 14px; margin-right: 10px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-send "><path d="m22 2-7 20-4-9-9-4Z"></path><path d="M22 2 11 13"></path></svg>
              </div>
              <div>
                Enviar Encuesta&nbsp;
              </div>
            </div>
          </f7-button>
        </div>
      </div>
    </f7-card>
  </f7-page>
</template>

<script>
/* eslint-disable */
import Question from './components/question.vue'
import { SurveyData, FlatSurvey } from './surveyData'
import { EventBus } from '../../utils/eventBus'

export default {
  components: { Question },
  data(){
    return {
      maxPages:1,
      currentPage:1,
      pages:[{id:"", page:1}],
      progress: {
        width: '0%'
      },
      survey: {},
      check: false,
      answers: [],
      endMessage:"La información personal se mantendrá estrictamente confidencial y no se venderá, reutilizará, alquilará, prestará ni divulgará de otro modo. Solo se utilizará como medio de contacto para hacerte llegar la cotización.",
      messageInBottom: ''
      //surveyId:''
    }
  },
  methods:{
    loadSurvey(){
      this.maxPages = this.survey.sections.length
      this.pages = this.survey.sections.map((item, index) => {
        return { id:item.id, page:index+1 }
      })
    },
    initEventBus(){
      EventBus.$on('update-answer', (payload) => {
        let exists = this.answers.find(resp => resp.id == payload.id);
        if(exists){
          if(Array.isArray(payload.value)){
            payload.value.forEach(item => {
              let img = exists.answer.find(img => img.name === item.name)
              if(img){
                item.name = img.name
                item.data = img.data
                item.remoteName = img.remoteName
              }
            })
            
            exists.answer = payload.value
          }
          else{
            exists.answer = payload.value
          }
        }
        else{
          this.answers.push({id:payload.id, answer:payload.value})
        }
      })

      EventBus.$on('upload-image', (data) => {
        this.answers.forEach((item) => {
          if(Array.isArray(item.answer)){
            item.answer.forEach((image)=>{
              if(image.name === data.original){
                image.remoteName = data.filename
                image.data=''
              }
            })
          }
        })
      })
    },
    updateProgress(){
      if(this.currentPage > this.maxPages){
        this.currentPage = this.maxPages
      }
      if(this.currentPage < 1){
        this.currentPage = 1
      }
      let localPercent = (1 / this.maxPages) * 100
      let percent = this.currentPage * localPercent
      this.progress = {
        width: percent + '%'
      }
      if(this.currentPage == this.maxPages){
        this.messageInBottom = this.endMessage
      }
      else{
        this.messageInBottom = ''
      }
    },
    movePages(pages){
      this.currentPage += pages
      this.updateProgress()
    },
    goPage(page){
      this.currentPage = page
      this.updateProgress()
    },
    sectionVisible(id){
      let page = this.pages.find(x => x.id === id)
      return page && page.page === this.currentPage
    },
    async sendForm(){
      let faltaPreguntas = false
      let flatSurvey = FlatSurvey()
      flatSurvey.forEach((question) => {
        let answer = this.answers.find(item => item.id === question.id)
        let surveyQuestion = null
        this.survey.sections.forEach(sections => {
          let findQuestion = sections.questions.find(q => q.id === question.id)
          if(findQuestion){
            surveyQuestion = findQuestion
          }
        })
        if(surveyQuestion && (surveyQuestion.type === "scale") && !answer){
          EventBus.$emit('update-answer', { id:surveyQuestion.id, value:`${surveyQuestion.min},${surveyQuestion.max}` })
          answer = { id:surveyQuestion.id, answer:`${surveyQuestion.min},${surveyQuestion.max}` }
        }
        if(!faltaPreguntas && surveyQuestion && surveyQuestion.required && !answer){
          faltaPreguntas = true
          this.$f7.dialog.alert(`La pregunta <b>${surveyQuestion.title}</b> no ha sido respondida y es obligatoria`, "MADAI", () => {})
        }
        if(!faltaPreguntas && surveyQuestion && surveyQuestion.pattern && answer && answer.answer){
          let pattern = new RegExp(surveyQuestion.pattern)
          let result = pattern.test(answer.answer)
          if(!result){
            faltaPreguntas=true
          }
        }
        if(answer){
          question.response = answer.answer
        }
      })
      if(faltaPreguntas){
        return
      }
      // console.log("Avanza",flatSurvey)
      this.$f7.dialog.preloader('Enviando la información...');
      await this.$api.envio.pcSendMail(flatSurvey)
      .then(resp => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert('El mensaje ha sido enviado, en breve nos contactaremos contigo.', `MADAI`, () => {
            setTimeout(() => {
              location.reload()
            }, 1000)
          })
      })
      .catch(err=>{
        console.log(err)
        this.$f7.dialog.close();
        this.$f7.dialog.alert(`Ocurrio un error al quere enviar tus datos. Por favor vuelve a presionar Enviar Encuesta`, "MADAI", () => {})    
      })
    }
  },
  mounted(){
    
    this.currentPage=1
    this.survey = SurveyData
    this.loadSurvey()
    this.updateProgress()
    this.initEventBus()
    //this.getNewId()
  },
  destroyed(){
    EventBus.$off('update-answer')
    EventBus.$off('upload-image')
  }
}
</script>

<style>
.end-message{
  text-align: justify;
  font-weight: 500;
}
.fpc-body{
  padding: 10px;
  color: rgb(10 36 63);
  background-color: #f5f5f5;
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  overflow: scroll;
}

.fpc-header{
  text-align: center;
  margin-bottom: 2rem;
}

.fpc-header-section{
  text-align: center;
  margin-bottom: 2rem;
}

.fpc-header p:first-child{
  font-weight: 600;
  font-size: 24px;
}

.fpc-header p:nth-child(2){
  font-weight: 600;
  font-size: 14px;
  font-weight: normal;
  color: rgb(168 168 168);
  margin: 0px;
}

.fpc-header-section p:first-child{
  font-weight: 600;
  font-size: 20px;
}

.fpc-header-section p:nth-child(2){
  font-weight: 600;
  font-size: 14px;
  font-weight: normal;
  color: rgb(168 168 168);
  margin-bottom: 30px;
}

.fpc-cards {
  max-width: 56rem;
  padding: 1.5rem;
  margin: 0px auto 30px auto;
}

.fpc-labels{
  font-size: 16px;
  font-weight: 500;
}

.fpc-separated {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
}

.fpc-progress{
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 9999px;
  height: 0.5rem;
  margin-bottom: 1rem;
}

.fpc-progress-up{
  background-color: #1d2244;
  height: 0.5rem;
  border-radius: 9999px;
  transition-property: all;
  transition-duration: 500ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.fpc-progress-icon-list{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  cursor: pointer;
}

.fpc-progress-icon{
  width: 100%;
  text-align: center;
}

.fpc-title-section{
  font-size: 10px;
  font-weight: 500;
}
</style>